var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Text } from '../Text';
import { PICKER_DATA_HOOKS, PICKER_DATA_PROPS } from './dataHooks';
import ChevronLeft from 'wix-ui-icons-common/on-stage/ChevronLeft';
import ChevronRight from 'wix-ui-icons-common/on-stage/ChevronRight';
import { IconButton } from '../IconButton';
import { st, classes } from './Picker.st.css';
/** Picker */
var Picker = /** @class */ (function (_super) {
    __extends(Picker, _super);
    function Picker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Picker.prototype.getDataAttributes = function () {
        var _a;
        var _b = this.props, prevDisabled = _b.prevDisabled, nextDisabled = _b.nextDisabled;
        return _a = {},
            _a[PICKER_DATA_PROPS.NextDisabled] = nextDisabled,
            _a[PICKER_DATA_PROPS.PrevDisabled] = prevDisabled,
            _a;
    };
    Picker.prototype.render = function () {
        var _a = this.props, onPrev = _a.onPrev, value = _a.value, onNext = _a.onNext, prevDisabled = _a.prevDisabled, nextDisabled = _a.nextDisabled, prevAriaLabel = _a.prevAriaLabel, nextAriaLabel = _a.nextAriaLabel, className = _a.className;
        return (React.createElement("div", __assign({ "data-hook": this.props['data-hook'], className: st(classes.root, {}, className) }, this.getDataAttributes()),
            React.createElement(IconButton, { className: classes.arrow, icon: React.createElement(ChevronLeft, null), onClick: function () { return (prevDisabled ? null : onPrev()); }, disabled: prevDisabled, "data-hook": PICKER_DATA_HOOKS.Prev, title: PICKER_DATA_HOOKS.Prev, "aria-label": prevAriaLabel }),
            React.createElement(Text, { role: "status", className: classes.value }, value),
            React.createElement(IconButton, { className: classes.arrow, icon: React.createElement(ChevronRight, null), onClick: function () { return (nextDisabled ? null : onNext()); }, disabled: nextDisabled, "data-hook": PICKER_DATA_HOOKS.Next, title: PICKER_DATA_HOOKS.Next, "aria-label": nextAriaLabel })));
    };
    Picker.defaultProps = {
        prevDisabled: false,
        nextDisabled: false,
        prevAriaLabel: '',
        nextAriaLabel: '',
    };
    return Picker;
}(React.Component));
export { Picker };
//# sourceMappingURL=Picker.js.map